

function viewSize() {
  return jQuery('#sizer').find('div:visible').data('size');
}

var viewport = viewSize();
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  //console.log("scroll function");
  var wrapper_navbar = document.getElementById("wrapper-navbar");
  var saller_logo       = document.getElementById("saller_logo");
  if (document.body.scrollTop > vhToPixels(20) || document.documentElement.scrollTop > vhToPixels(20)) {
    //console.log("drin");
    wrapper_navbar.classList.add("wrapper-navbar_sticky");
    wrapper_navbar.classList.remove("pt-2");
    wrapper_navbar.classList.remove("pb-2");
    saller_logo.classList.add("saller_logo_sticky");
    //main_nav.classList.remove("mt-3");
  } else {
    //console.log("raus");
      wrapper_navbar.classList.remove("wrapper-navbar_sticky");
      wrapper_navbar.classList.add("pt-2");
      wrapper_navbar.classList.add("pb-2");
      saller_logo.classList.remove("saller_logo_sticky");
     // main_nav.classList.add("mt-3");
    
  }
} 

function vhToPixels (vh) {
  //console.log(Math.round(window.innerHeight / (100 / vh)-20));
  return Math.round(window.innerHeight / (100 / vh)-20);
}

//var leistungen = document.getElementById("menu-item-dropdown-66");
//leistungen.classList.add("nav-leistungen");

let items = document.querySelectorAll('#carouselActual .carousel-item')

items.forEach((el) => {
   
    const minPerSlide = 4 //was 3
    let next = el.nextElementSibling
    for (var i=1; i<minPerSlide; i++) {
   
        if (!next) {
            // wrap carousel by using first child
        	next = items[0]
      	}
        let cloneChild = next.cloneNode(true)
        el.appendChild(cloneChild.children[0])
        next = next.nextElementSibling
    }
})

var intFrameWidth = window.innerWidth;
if (intFrameWidth > 767) {
    const carAn = document.getElementById("carouselActual");
    if(carAn != null) {
        carAn.setAttribute("data-bs-touch","false");
    }
}

function set_carousel_class() {
    //mobile
    if (window.screen.width < 800) {
        let items = document.querySelectorAll('.is-caro-item')
        let inners = document.querySelectorAll('.carousel-inner')
        items.forEach((el) => {
            el.classList.add("carousel-item");
        })

        inners.forEach((el) => {
            el.classList.add("flex-nowrap");
        })
    }
    if (window.screen.width >= 800) {
        let items = document.querySelectorAll('.is-caro-item')
        let inners = document.querySelectorAll('.carousel-inner')

        items.forEach((el) => {
            el.classList.remove("carousel-item");
        })
        inners.forEach((el) => {
            el.classList.remove("flex-nowrap");
        })
    }
}

set_carousel_class();
window.onresize = function(){
    console.log("resize happend");
    set_carousel_class();
}

jQuery(document).ready(function($) {
  /**
  var styleBackup = '', restOfTimeout = 500, currentState = '', freeze = false;
  $('.client-slider').on('init', function (event, slick, direction) {
      const observer = new MutationObserver(function (mutationsList, observer) {
          for (const mutation of mutationsList) {
              if (mutation.type === 'attributes' && mutation.attributeName == 'style' && freeze) {
                  $('.client-slider .slick-track').css('transform', currentState);
              }
          }
      });
      observer.observe($('.client-slider .slick-track')[0], { attributes: true });
      $('.client-slider .slick-track').mouseover(function () {
          styleBackup = $('.client-slider .slick-track').attr('style');
          currentState = getComputedStyle($('.client-slider .slick-track')[0]).transform;
          freeze = true;
          $('.client-slider').slick('slickPause');
          let translateDone = parseFloat(currentState.split(',')[4]) * (-1);
          let regex = /translate3d\(([^,]*),/gm;
          if ((m = regex.exec(styleBackup)) !== null) {
              let translateNeed = parseFloat(m[1]) * (-1);
              let slideWidth = $('.client-slider .slick-slide').first().width();
              let speed = 5000 / slideWidth;
              restOfTimeout = (translateNeed - translateDone) * speed;
              var report = "Should be: " + translateNeed + "\n";
              report += "Did on hover moment: " + translateDone + "\n";
              report += "Still has to scroll: " + (translateNeed - translateDone) + "px\n";
              report += "Speed of scroll: " + speed + "ms\n";
              report += "Desired timeout: " + restOfTimeout + "ms\n";
              $('#report').text(report);
          } else {
              restOfTimeout = 500;
          }
          $('.client-slider .slick-track').css('transform', currentState);
      });
      $('.client-slider .slick-track').mouseout(function () {
          freeze = false;
          $('.client-slider .slick-track').attr('style', styleBackup.replace('5000ms', restOfTimeout + 'ms'));
          $('.client-slider').slick('slickPlay');
      });
  });
   */
  if( $('body.home').length ){
  $('.photo-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      infinite: true,
      cssEase: 'linear',
      centerMode: true,
      centerPadding:'200px',
      variableWidth: true,
      arrows: false,
      dots: true,
      pauseOnHover: false,
      mobileFirst:true,
      responsive: [{
          breakpoint: 1024,

          settings: {
              slidesToShow: 1,
              slidesToScroll: 2,
              variableWidth: true,
              arrows: true,
              dots: true,
              centerPadding:'10%',

          }
      }, {
          breakpoint: 768,

          settings: {
              slidesToShow: 1,
              variableWidth: true,
              dots: true,
              arrows: false,
              centerPadding:'10%',
          }
      }, {
          breakpoint: 576,

          settings: {
              slidesToShow: 1,
              variableWidth: true,
              dots: true,
              arrows: false,
              centerPadding:'10%',
          }
      }]
  });
}
//refresh AOS to prevent fade errors
  AOS.refresh();
});
/**
jQuery(document).ready(function($) {
$('.carousel .carousel-item').each(function(){
  var minPerSlide = 3;
  var next = $(this).next();
  if (!next.length) {
  next = $(this).siblings(':first');
  }
  next.children(':first-child').clone().appendTo($(this));
  
  for (var i=0;i<minPerSlide;i++) {
      next=next.next();
      if (!next.length) {
        next = $(this).siblings(':first');
      }
      
      next.children(':first-child').clone().appendTo($(this));
    }
});
});
*/

